import { render, staticRenderFns } from "./AdvertisementsHistory.vue?vue&type=template&id=fc1b9888"
import script from "./AdvertisementsHistory.vue?vue&type=script&lang=js"
export * from "./AdvertisementsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports